import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const ChatIcon = ({ title = 'Chat', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.692 3.564h14.616A2.692 2.692 0 0122 6.257v8.846a2.692 2.692 0 01-2.692 2.692h-4.523l-1.97 1.97a1.154 1.154 0 01-1.577.052l-.055-.052-1.968-1.97H4.692a2.692 2.692 0 01-2.69-2.6L2 15.103V6.257a2.692 2.692 0 012.692-2.693zm14.616 2.308H4.692a.385.385 0 00-.384.384v8.846c0 .213.172.385.384.385h5c.307 0 .6.122.817.338l1.49 1.492 1.493-1.492c.198-.198.462-.317.74-.335l.076-.003h5a.385.385 0 00.384-.385V6.256a.385.385 0 00-.384-.384z"
    />
  </CreateIconComponent>
);

export default ChatIcon;
